<!--
使用方法
<MaxMinInput v-model="val" :precision="item.precision" />
// precision：精度 选填
-->

<template>
  <div
    ref="reference"
    class="el-date-editor el-range-editor el-input__inner el-range-editor--small"
    :class="isFoucs ? 'is-active' : ''"
    style="width: 200px"
  >
    <input
      v-model="value[0]"
      autocomplete="off"
      placeholder="最小值"
      class="el-range-input"
      @focus="isFoucs = true"
      @blur="isFoucs = false"
      @change="handleStartChange"
    >

    <span class="el-range-separator">—</span>

    <input
      v-model="value[1]"
      autocomplete="off"
      placeholder="最大值"
      class="el-range-input"
      @focus="isFoucs = true"
      @blur="isFoucs = false"
      @change="handleEndChange"
    >

  </div>

</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => ([null, null])
    },
    precision: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      isFoucs: false
    }
  },

  methods: {
    handleFocus() {
      this.isFoucs = true
    },

    calV(v) {
      let value = v.trim()
      // '' undefined 0 sss 4d d4
      // Number()
      // 0 NaN 0 NaN NaN NaN
      // parseFloat()
      // NaN NaN 0 NaN 4 NaN
      // (value !== '') && (value = Number(value))
      value = parseFloat(value)

      if (isNaN(value)) {
        value = undefined
      } else if (value < 0) {
        value = undefined
      } else if (typeof this.precision === 'number') {
        value = Number(value.toFixed(this.precision))
      }

      return value
    },

    handleStartChange(e) {
      let value = this.calV(e.target.value);
      (value > this.value[1] && this.value[1] !== '') && (value = undefined)

      this.$emit('change', [value, this.value[1]])
      this.isFoucs = false
    },
    handleEndChange(e) {
      let value = this.calV(e.target.value);

      (value < this.value[0]) && (value = undefined)

      this.$emit('change', [this.value[0], value])
      this.isFoucs = false
    }
  }
}
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}
.el-date-editor{
  width: 200px;
  display: flex;
  justify-content: space-between;
}
.el-date-editor .el-range-input {
  width: 45%;
}

.el-date-editor .el-range-separator {
  padding: 0
}
</style>
